// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React from "react";
import {useDispatch} from "react-redux";
import {toAbsoluteApiUrl, toAbsoluteUploadUrl, toAbsoluteUrl,} from "../../../../_metronic/_helpers";
// import {EnabledColumnFormatter, PremiumColumnFormatter, UpdatedAtColumnFormatter, CreatedAtColumnFormatter} from "../../_AE/column-formatters";
import {Card, CardBody, CardFooter} from "../../../../_metronic/_partials/controls";
import {useModuleContext} from "../ModuleContext";
import {AESVG} from "../../../../_emywork/components/svg";
import {AEButton} from "../../../../_emywork/components/buttons";
import {useIntl} from "react-intl";
import {AECurrency} from "../../../../_emywork/components/Currency";
import {AERating} from "../../../../_emywork/components/rating";
import * as actions from "../_redux/actions";
import {actionTypes} from "../_redux/slice";
import {AELabels} from "../../../../_emywork/components/AELabel";
import {EntityCard as UserEntityCart} from "../../Users/componants/EntityCard";
import {ModuleProvider as UserModuleProvider} from "../../Users/ModuleContext";
import {ModuleProvider as ChatModuleProvider} from "../../Chat/ModuleContext";
import {AELink} from "../../../../_emywork/components/AELink";


export function EntityCard({
  entity,
  size= "md",
  showUser = true,
  editAction = false,
  detailsAction = false,
  sendProposalAction= false,
  deleteAction = false,
  className = ''
}) {
  const { formatMessage } = useIntl()
  const dispatch  = useDispatch()
  const { openDetailsPage, getDetailsPath } = useModuleContext()
  const { id, slug, title, created_by, subcategories, description, user_id,
    skills = [], location, images = [],
    price, rating, reviews_count, is_saved
  } = entity;

  const openDetailsPageHandler = () => { openDetailsPage(slug) }


  return (
    <Card className={`card-stretch ${is_saved ? '-border border-primary border-2' : ''}`}>
      <div className="-position-relative">
        <div className="card card-custom overlay">
          <div className="card-body p-0">
            <div className="overlay-wrapper">
              <img
                src={
                  images.length === 0 ?
                    toAbsoluteUrl(`/media/logos/logo-dark.png`):
                    toAbsoluteUploadUrl(`/emy_service_images/${images[0].id}/${images[0].file_name}`)
                }
                alt=""
                className="w-100 max-h-175px rounded-top"
              />
            </div>

            <div className="overlay-layer align-items-end justify-content-end p-5 rounded-top">
              <AEButton
                variant={'clean'}
                onClick={event => {
                  dispatch(actions.toggleSave(id, !is_saved, actionTypes.List))
                }}
                icon
              >
                <AESVG path={"/General/Heart.svg"} variant={is_saved ? 'danger':'light'} size={"2x"}/>
              </AEButton>
              <AELink
                to={getDetailsPath(slug)}
                className={'btn btn-clean btn-icon'}
              >
                <AESVG path={"/General/Expand-arrows.svg"} size={"2x"}/>
              </AELink>
              {/*<AEButton*/}
              {/*  variant={'clean'}*/}
              {/*  onClick={openDetailsPageHandler}*/}
              {/*  icon*/}
              {/*>*/}
              {/*  <AESVG path={"/General/Expand-arrows.svg"} size={"2x"}/>*/}
              {/*</AEButton>*/}
            </div>
          </div>
        </div>
      </div>
      <CardBody className={`p-3 d-flex flex-column`}>
        <div className="pl-2 py-1">
          <AELink
            to={getDetailsPath(slug)}
            className={'font-weight-bold text-primary text-hover-primary'}
          >
            {title}
          </AELink>
        </div>
        <AELabels variant={'light-primary'} options={subcategories} />
        <AELabels variant={'light-secondary'} options={skills} />
        {
          showUser &&
            <ChatModuleProvider>
              <UserModuleProvider>
                <UserEntityCart size={'xs'} entity={created_by} className={'mt-auto mb-0 pt-2'}/>
              </UserModuleProvider>
            </ChatModuleProvider>

        }

        {/*<div className={`d-flex align-items-center py-3 mt-auto`}>*/}
        {/*  <div className="symbol symbol-40 symbol-sm flex-shrink-0">*/}
        {/*    <span className={'symbol-label'}>*/}
        {/*      {*/}
        {/*        created_by.file_name ?*/}
        {/*          <img src={toAbsoluteApiUrl(`/users/${created_by.file_name}`)} alt="image"/>*/}
        {/*          :*/}
        {/*          <img*/}
        {/*            src={toAbsoluteUrl('/media/svg/avatars/001-boy.svg')}*/}
        {/*            className="h-75 align-self-end" alt=""*/}
        {/*          />*/}
        {/*      }*/}
        {/*    </span>*/}
        {/*  </div>*/}
        {/*  /!* TODO use userEntity Card*!/*/}
        {/*  */}
        {/*  <div className="ml-4">*/}
        {/*    <div className="text-dark-75 font-weight-bolder font-size-lg mb-0">*/}
        {/*      @{created_by.username}*/}
        {/*    </div>*/}
        {/*    <a href="#" className="font-weight-bold text-primary text-hover-primary"*/}
        {/*      onClick={openDetailsPageHandler}*/}
        {/*    >*/}
        {/*      {title}*/}
        {/*    </a>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </CardBody>
      <CardFooter className={"bg-primary text-white py-3 px-2"}>
        <div className="d-flex justify-content-between">
          <div>
            <AERating value={rating} />
            <div className={'pl-1'}>
              {formatMessage({id:'REVIEW.COUNT'},{count:reviews_count})}
            </div>
          </div>
          <div className="">
            {formatMessage({id:'STARTING_AT'})}
            <div className={'font-weight-bolder h4 mr-2'}>
              <AECurrency value={price} />
            </div>
          </div>
        </div>
      </CardFooter>
    </Card>)
}
